import { EdgeLoadBirdHarvestsRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadBirdHarvests } from '@/shared/domain/use-cases'

export function makeLoadBirdHarvests(): LoadBirdHarvests {
  return new EdgeLoadBirdHarvestsRepository(makeSupabaseEdgeHttpClient()).execute
}
